export const requestIdleCallback =
	window.requestIdleCallback || ((cb) => setTimeout(cb, 0));
export const cancelIdleCallback =
	window.cancelIdleCallback || ((id) => clearTimeout(id));
